module.exports = __webpack_public_path__ + "img/info-sys.d54f840d.svg";